import { useMemo } from 'react';

/**
 * 计算节点距离左部、顶部的距离
 * @param {DOMRect} element 
 * @returns
 */
const useOffset = (element) => {
  const offset = useMemo(() => {
    let pos = { left: 0, top: 0 };
    if (!element) {
      return pos;
    }
    const { offsetLeft, offsetTop } = element;
    let { offsetParent } = element;
    
    pos.left += offsetLeft
    pos.top += offsetTop
  
    while (offsetParent && !/html|body/i.test(offsetParent.tagName)) {
      pos.left += offsetParent.offsetLeft
      pos.top += offsetParent.offsetTop
  
      offsetParent = offsetParent.offsetParent
    }
    return pos
  }, [element]);
  return offset;
};

export default useOffset;